<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <navigation
            :list="segments"
            :active-value="activeSegment"
            variety="segmented"
            @active:updated="tapNavigation"
          />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <keep-alive>
            <component :is="activeSegmentComponent" />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from '~components/common/Navigation'
import EnrolledHistory from './nested/EnrolledHistory'
import StudentAccountSettings from './nested/AccountSettings'

export default {
  name: 'StudentIndexContent',
  components: {
    Navigation,
    EnrolledHistory,
    StudentAccountSettings
  },
  data () {
    return {
      segments: ['活動紀錄', '資料管理'],
      segmentComponents: [EnrolledHistory, StudentAccountSettings],
      activeSegment: '資料管理'
    }
  },
  computed: {
    activeSegmentComponent () {
      return this.segmentComponents[this.segments.indexOf(this.activeSegment)]
    }
  },
  created () {
    const specificSegment = this.$route.query.tab
    if (specificSegment) {
      this.updateActiveSegment(specificSegment)
    }
  },
  methods: {
    tapNavigation (segment) {
      this.updateActiveSegment(segment)
      this.pushTabQuery(segment)
    },
    pushTabQuery (segment, sub) {
      if (sub) {
        this.$router.push({
          path: '/students',
          query: {
            tab: segment,
            sub
          }
        })
      } else {
        this.$router.push({
          path: '/students',
          query: {
            tab: segment
          }
        })
      }
    },
    updateActiveSegment (segment) {
      this.activeSegment = segment
    }
  }
}
</script>
